import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';

const SkeletonRow = styled.div`
  display: flex;
  padding: ${spacing.base};
`;

export const testIds = {
  skeleton: 'segmentation-insights-table-skeleton',
};

export const ResultsTableSkeleton = ({
  numRows = 6,
  numColumns = 8,
}: {
  numRows?: number;
  numColumns?: number;
}) => {
  return (
    <div data-test={testIds.skeleton}>
      {Array(numRows)
        .fill({})
        .map((x, rowId) => (
          <SkeletonRow key={rowId}>
            <Skeleton height={50} width={580} />
            {Array(numColumns)
              .fill({})
              .map((y, colId) => (
                <Skeleton key={colId} height={50} width={160} />
              ))}
          </SkeletonRow>
        ))}
    </div>
  );
};
